import app from 'flarum/forum/app';

app.initializers.add('foskym/flarum-multi-mailer', () => {
  console.log('[foskym/flarum-multi-mailer] Hello, forum!');
});
